import { gql } from '@apollo/client';

export const getLuzmoToken = gql`
  query GetLuzmoToken @api(name: "user") {
    getLuzmoToken {
      authKey
      expireAt
      token
    }
  }
`;

export const partnerUserList = gql`
  query partnerUserList(
    $pagination: PaginationInput
    $sortBy: [UserForPartnerSortInput!]
    $searchBy: String
    $showPartnerTeam: Boolean
    $showFacilityTop: Boolean
  ) @api(name: "user") {
    partnerUserList(
      pagination: $pagination
      sortBy: $sortBy
      searchBy: $searchBy
      showPartnerTeam: $showPartnerTeam
      showFacilityTop: $showFacilityTop
    ) {
      hits {
        id
        firstName
        lastName
        username
        businessName
        teamTitle
        planTitle
      }
      itemsCount
      currentPage
      pageCount
    }
  }
`;

export const getUserProfile = gql`
  query fetchProfile($userId: Int!) @api(name: "user") {
    userData: getProfile(userId: $userId) {
      firstName
      lastName
      accountId
      baseUser {
        email
      }
      isInviteEmailSent
      userGroupId
    }
  }
`;

export const getBusinessProfile = gql`
  query getBusinessProfile($accountId: Int!) @api(name: "user") {
    getBusinessProfile(accountId: $accountId) {
      accountId
      name
      email
      phone
    }
  }
`;

export const whetherUserExists = gql`
  query whetherUserExists($email: String!, $userId: Int) @api(name: "user") {
    isUserExists: whetherUserExists(email: $email, userId: $userId)
  }
`;

export const getWhiteLabel = gql`
  query getWhiteLabel($accountId: Int!) @api(name: "user") {
    whiteLabel: getWhiteLabel(accountId: $accountId) {
      accountId
      name
      email
      estimateEmail
      address
      city
      state
      postal
      site
      description
      financeUrl
      colors
      logoUrl
    }
  }
`;

export const getStaffTeams = gql`
  query getStaffTeams($accountId: Int!) @api(name: "user") {
    getStaffTeams(accountId: $accountId) {
      id
      alias
      title
    }
  }
`;

export const getUserFeatures = gql`
  query getUserFeatures @api(name: "user") {
    getUserFeatures
  }
`;
